import { Button, Divider, Group, Stack } from "@mantine/core";
import LeadsSearch from "./LeadsSearch";
import LeadsFilter from "./LeadsFilter";
import ReloadButton from "./ReloadButton";
import StatusSettings from "../titleSection/status/StatusSettings";
import PopOver from "../../../../components/View/PopOver";
import { IconDotsVertical } from "@tabler/icons-react";
import LeadsExport from "./LeadsExport";
import LeadsDelete from "./LeadsDelete";
import { useProfileStore } from "../../../../stores/UserStore";
import { useParams } from "react-router-dom";
import LeadsJobs from "./LeadsJobs";
import { getPermission } from "../../../../functions/utilFunctions";
import LeadsCopyToList from "./copy/LeadsCopyToList";
import LeadsBulkNewReply from "./LeadsBulkNewReply";
import LeadsQuickNewFilter from "./LeadsQuickNewFilter";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../stores/LeadsStore";
import LeadsBulkTags from "./LeadsBulkTags";
import LeadsBulkZapier from "./zapier/LeadsBulkZapier";
import LeadsBulkMake from "./make/LeadsBulkMake";
import PrmLayoutChanger from "./PrmLayoutChanger";
import LeadsEnrichPhone from "./LeadsEnrichPhone";
import LeadsEnrichEmail from "./LeadsEnrichEmail";
import LeadsEnrichContactout from "./LeadsEnrichContactout";
import ContactsExteriorFiltersControlled from "../../lists/components/ContactsExteriorFiltersControlled";
import LeadsBlacklist from "./blacklist/LeadsBlacklist";

const Controller = () => {
  const { userId } = useParams();
  const profile = useProfileStore((s) => s.profile);
  const loading = useLeadsContainerStore((s) => s.reloadAll);
  const setReloadAll = useLeadsContainerStore((s) => s.setReloadAll);
  const filter = useLeadsStore((s) => s.filter);
  const setFilter = useLeadsStore((s) => s.setFilter);

  const differentPrm = userId ? profile?.id !== parseInt(userId) : false;

  const loadingJobs = useLeadsStore((s) => s.loadingJobs);
  const setLoadingJobs = useLeadsStore((s) => s.setLoadingJobs);

  const screenIsLarge = window.innerWidth > 1800;

  return (
    <Group gap={0} mb={2} mt={-6}>
      {/* <LeadsMoverTech /> */}
      <LeadsSearch />
      <LeadsFilter />

      <StatusSettings disabled={differentPrm} />

      <PopOver
        opener={(handleOpen, ref) => (
          <Button
            variant="subtle"
            size={"sm"}
            ml={16}
            mr={8}
            miw={0}
            w={38}
            p={0}
            radius={"md"}
            ref={ref}
            onClick={handleOpen}
          >
            <IconDotsVertical size={24} />
          </Button>
        )}
        popoverChildren={(handleClose) => (
          <Stack gap={6}>
            {getPermission("exportPRM") && (
              <LeadsExport handleClose={handleClose} />
            )}

            <LeadsCopyToList handleClose={handleClose} />

            <LeadsBulkNewReply handleClose={handleClose} />

            <LeadsBulkTags handleClose={handleClose} />

            <LeadsBulkZapier handleClose={handleClose} />

            <LeadsBulkMake handleClose={handleClose} />

            {getPermission("findMobilePhone") && (
              <LeadsEnrichPhone
                handleClose={handleClose}
                setLoadingJobs={setLoadingJobs}
              />
            )}

            {profile?.level === "admin" && (
              <LeadsEnrichEmail
                handleClose={handleClose}
                setLoadingJobs={setLoadingJobs}
              />
            )}

            {profile?.level === "admin" && (
              <LeadsEnrichContactout
                handleClose={handleClose}
                setLoadingJobs={setLoadingJobs}
              />
            )}

            <LeadsBlacklist handleClose={handleClose} />

            <LeadsDelete handleDone={handleClose} />
          </Stack>
        )}
      />

      <LeadsQuickNewFilter />

      <ContactsExteriorFiltersControlled
        filter={filter}
        setFilter={setFilter}
        loading={loading}
        screenIsLarge={screenIsLarge}
        filterKey="prm"
        onApplied={() => setReloadAll(true)}
      />

      <PrmLayoutChanger />

      <Group ml={"auto"} gap={0} justify="end" mr={32}>
        <LeadsJobs loading={loadingJobs} setLoading={setLoadingJobs} />
      </Group>

      <ReloadButton />
    </Group>
  );
};

export default Controller;
